import SmoothScroll from "smooth-scroll";

export default function() {
    var heroScroll = new SmoothScroll('a[href="#countdown-content"]', {
        updateURL: false
    });
}